/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  async getCacheKeys() {
    const response = await axios.get(
      `/api/v1/accounts/${this.accountIdFromRoute}/cache_keys`
    );
    return response.data.cache_keys;
  }

  getBillingSubscription() {
    return axios.get(`/api/v1/accounts/${this.accountIdFromRoute}/billing/subscription`);
  }

  getBillingPlans() {
    return axios.get(`/api/v1/accounts/${this.accountIdFromRoute}/billing/plans`);
  }

  getAddons() {
    return axios.get(`/api/v1/accounts/${this.accountIdFromRoute}/billing/addons`);
  }

  checkoutBilling(planId) {
    return axios.post(`/api/v1/accounts/${this.accountIdFromRoute}/billing/checkout`, { plan_id: planId });
  }

  billingPortal() {
    return axios.post(`/api/v1/accounts/${this.accountIdFromRoute}/billing/portal`);
  }

  checkoutAddon(addonPlanId) {
    return axios.post(`/api/v1/accounts/${this.accountIdFromRoute}/billing/addon_checkout`, { addon_plan_id: addonPlanId });
  }
}

export default new AccountAPI();
